import { ActivatedRouteSnapshot, CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';
import { CONTEXT_IDS, STORAGE_KEYS } from './app.constants';
import { inject } from '@angular/core';
import { StorageService } from './providers/storage.service';

export const flowSkinGuard: CanActivateFn = (next: ActivatedRouteSnapshot) => {
  const skinParam = next.queryParamMap.get('skin');
  switch (skinParam) {
    case 'dev':
      return createUrlTreeFromSnapshot(next, ['dev'], next.queryParams);
    case 'ibc':
      return createUrlTreeFromSnapshot(next, ['ibc'], next.queryParams);
    default:
      // default to tailwind
      return createUrlTreeFromSnapshot(next, ['tw'], next.queryParams);
  }
};

export const authGuard: CanActivateFn = (next: ActivatedRouteSnapshot) => {
  const authStorage = inject(StorageService);
  const validationToken = next.queryParamMap.get('validationToken');
  const authToken = next.queryParamMap.get('authToken');
  const activityId = next.queryParamMap.get('activityId');
  const apiKey = next.queryParamMap.get('apiKey');
  const flowId = next.queryParamMap.get('flowId');
  if ((authToken || validationToken) && apiKey && flowId) {
    if (validationToken) {
      authStorage.setItem(STORAGE_KEYS.VALIDATION_TOKEN, validationToken);
    }
    if (authToken) {
      authStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, authToken);
    }
    if (activityId) {
      authStorage.setItem(STORAGE_KEYS.ACTIVITY_ID, activityId);
    }
    authStorage.setItem(STORAGE_KEYS.FLOW_ID, flowId);
    authStorage.setItem(STORAGE_KEYS.API_KEY, apiKey);
    return true;
  } else {
    return createUrlTreeFromSnapshot(next, ['/unauthorized'], next.queryParams);
  }
};

export const contextGuard: CanActivateFn = (next: ActivatedRouteSnapshot) => {
  const storage = inject(StorageService);
  const contextParam = next.queryParamMap.get('context');

  if (contextParam) {
    storage.setItem(STORAGE_KEYS.CONTEXT_ID, contextParam);
  } else {
    // fallback - calculate the context
    const authTokenParam = next.queryParamMap.get('authToken');
    const syncParam = next.queryParamMap.get('syncProcessing');

    if (!authTokenParam) {
      storage.setItem(STORAGE_KEYS.CONTEXT_ID, CONTEXT_IDS.INDEPENDENCE);
    } else if (syncParam && syncParam === 'true') {
      storage.setItem(STORAGE_KEYS.CONTEXT_ID, CONTEXT_IDS.CHATBOT);
    } else {
      storage.setItem(STORAGE_KEYS.CONTEXT_ID, CONTEXT_IDS.VOYAGE);
    }
  }
  return true;
};
